import { Component } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import TitleTextGroup from './TitleTextGroup';
import * as InternalPropTypes from '../../../constants/internal-types';
import {
  TypeFactBoxTypes,
  FactBoxEnum,
  TypeSEOWeightTypes,
} from '../../../constants/cms-constants';
import TitleTypes from '../../../constants/title-types';
import SEOWeights from '../../../constants/cms/control-options/seo-weights';

type FactBoxProps = {
  type?: TypeFactBoxTypes;
  titleText?: InternalPropTypes.RichText;
  bodyText?: InternalPropTypes.RichText;
  styling?: Interpolation<Theme>;
  seoWeight?: TypeSEOWeightTypes;
};

class FactBox extends Component<FactBoxProps> {
  static types = FactBoxEnum;

  static defaultProps = {
    type: this.types.CONTACT,
    titleText: null,
    bodyText: null,
    styling: null,
    seoWeight: SEOWeights.H3,
  };

  render() {
    const { type, titleText, bodyText, styling, seoWeight } = this.props;

    function getKeyByValue(object, value) {
      return Object.keys(object).find((key) => object[key] === value);
    }

    const titleType = getKeyByValue(TitleTypes, type);

    return (
      <div css={styling}>
        <TitleTextGroup
          bodyText={bodyText}
          titleText={titleText}
          type={TitleTypes[titleType]}
          seoWeight={seoWeight}
        />
      </div>
    );
  }
}

export default FactBox;
